import { AnalyticsStore } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';
import AffiliateHubLogger from '../../util/affiliate-hub-logger';

const logger = new AffiliateHubLogger(ClientLogger.getLoggerWithIdentifier(`event_dispatcher`));

function dispatchEvent(analytics: AnalyticsStore, event: string, link: string, microMessages: any[]): void {
  if (analytics?.trackEvent) {
    analytics.trackEvent(
      event,
      link,
      null, // omnitureData
      null, // events
      true, // trackImmediate
      microMessages,
    );
  } else {
    // TODO: Store these "lost" analytics events and re-publish when we can
    logger.warn(`event=analytics_store_missed_event, event=${event}, link=${link}`, microMessages);
  }
}

export { dispatchEvent };
